var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 16.0125L8.6625 15.0225C4.8 11.52 2.25 9.21 2.25 6.375C2.25 4.065 4.065 2.25 6.375 2.25C7.68 2.25 8.9325 2.8575 9.75 3.8175C10.5675 2.8575 11.82 2.25 13.125 2.25C15.435 2.25 17.25 4.065 17.25 6.375C17.25 9.21 14.7 11.52 10.8375 15.03L9.75 16.0125Z",
    fill: "#5F6368"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/Heart.5ad828690bf45471345d9939421378ae.svg";
export { ForwardRef as ReactComponent };